import * as React from 'react';

import ResetFormEmail from '../containers/auth/ResetFormEmail';


export default function() {
  return (
    <React.Fragment>
      <div className="log__cont log__cont--reset">
        <ResetFormEmail />
      </div>
    </React.Fragment>
  );
};

